import { Min, ValidateIf } from 'class-validator';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { toastError, toastSuccess } from 'src/actions/toast';

export class DataRetentionConfig {
  enabled: boolean;

  @ValidateIf(props => props.enabled === true)
  @Min(365, { message: 'Enter a value of 365 or more' })
  retentionDays: number;
}

const dataRetentionConfigurationResource = createDocumentResource<DataRetentionConfig>({
  name: 'customerDataRetentionConfig',
  endpoint: 'v1/orgs/:orgId/configuration/customerdataretention',
  type: DataRetentionConfig,
  observerCreator: emptyObserverCreator,
});

const update: sharedTypes.AppThunk =
  (params: any, attrs: DataRetentionConfig) =>
  async (dispatch, getState, { gateways }) => {
    const { updateStarted, updateSuccess, updateError, updateRequestError } =
      dataRetentionConfigurationResource.actions;

    try {
      dispatch(updateStarted({}));
      await gateways[dataRetentionConfigurationResource.name].update(params, attrs);
      dispatch(updateSuccess({}));

      const message = attrs.enabled
        ? `Updated data retention policy to delete customer data after ${attrs.retentionDays} days`
        : 'Update successful!';

      dispatch(toastSuccess(message));
    } catch (error) {
      handleStandardErrors({ error, dispatch, handleDomainError: updateError, handleDefaultError: updateRequestError });

      dispatch(toastError('There was an error while updating'));
    }
  };

dataRetentionConfigurationResource.effects.update = update;

export default dataRetentionConfigurationResource;
